module.exports = __webpack_public_path__ + "img/mini-logo.fb79a018.png";